import React, { useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
import styles from "./product.module.scss";
import Timer from "./timer";
import useWindowSize from "../../hooks/useWindowSize";
import { content } from "../../utils/content/product";
import LazyLoad from "react-lazyload";
// import Image from "next/image";

const ProductBrief = ({ product = {}, lang }) => {
  const size = useWindowSize();
  const myLoader = ({ src }) => {
    return src + `?tr=w-${size.width}`;
  };

  useEffect(() => {}, [product.price, product.offer_price]);
  return (
    <div className="font-sans">
      <h1 className="md:mt-2 text-xl font-bold">
        {product.name ? product.name : ""}
      </h1>
      {product.no_of_books ? (
        <h4 className="mt-2 text-base text-gray-500 font-medium">
          {product.no_of_books} {content["books"][lang]}
        </h4>
      ) : (
        ""
      )}
      <div className="hidden md:flex mt-2 gap-3 text-base text-gray-400 items-center">
        {/* {product.rating? Math.round(product.rating * 10) / 10: "Product is not rated yet"} */}
        {product.rating ? (
          <span className="inline-flex rounded-lg items-center px-3 py-1 text-base font-medium bg-tn-green text-white">
            {Math.round(product.rating * 10) / 10 > 0
              ? Math.round(product.rating * 10) / 10
              : ""}
            <button
              type="button"
              className="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-white"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            </button>
          </span>
        ) : (
          "Product is not rated yet"
        )}

        <p className="text-base text-gray-400 fon-medium">
          {product.numOfReviews > 0
            ? `${product.numOfReviews} ${content["reviews"][lang]}`
            : null}
        </p>
      </div>
      <div className={`${styles.extraSmall}`}>
        <h3 className="mt-7 hidden text-base md:block text-tn-green font-bold">
          Extra ₹ {product.price - product.offer_price} off
        </h3>
        <div className="flex sm:gap-6 gap-3  items-center mt-1">
          <h3 className="text-xl font-bold">₹ {product.offer_price}</h3>
          <h4 className="text-gray-400 line-through font-bold text-xl">
            {" "}
            ₹ {product.price}
          </h4>
          <h4 className="text-xl text-tn-green font-bold">
            {(
              ((product.price - product.offer_price) / product.price) *
              100
            ).toFixed(0)}
            % {content["percentageOff"][lang]}
          </h4>
        </div>
      </div>

      <div className="flex md:hidden mt-3 gap-4 text-sm text-gray-400 items-center">
        {product.rating ? (
          <span className="inline-flex rounded-full items-center my-2 pl-2.5 pr-1 text-base font-medium bg-tn-green text-white">
            {Math.round(product.rating * 10) / 10 > 0
              ? Math.round(product.rating * 10) / 10
              : ""}
            <button
              type="button"
              className="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center "
            >
              <span className="sr-only">Remove large option</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-white"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            </button>
          </span>
        ) : (
          ""
        )}
        <p className="text-base fon-bold">
          {product.numOfRatings > 0
            ? `${product.numOfRatings} ${content["ratings"][lang]}`
            : null}{" "}
          {product.numOfReviews ? content["and"][lang] : ""}{" "}
          {product.numOfReviews > 0
            ? `${product.numOfReviews} ${content["reviews"][lang]}`
            : null}
        </p>
      </div>
      <div className="flex items-center gap-2 my-6">
        <img src="/img/tag.png" alt="tag" className="h-5" />
        <p className="text-base text-gray-400 mb-0">
          {content["tagline"][lang]}
        </p>
        <img src="/img/tag.png" alt="tag" className="h-5" />
      </div>
      <Timer lang={lang} />
      {product && product.offerings && product.offerings.offering_name ? (
        <div className="mt-20">
          <h3 className="font-bold my-0 sm:text-xl text-base heading-primary-blue w-100">
            Offerings Available
          </h3>
          <div className="flex flex-wrap gap-x-9 gap-y-4 mt-3">
            {product.offerings.map((item) => (
              <button className="sm:px-12 sm:py-3 px-6 py-2 sm:text-2xl text-base border-2 border-dark-blue hover-change-bg bg-transparent rounded-lg font-bold heading-primary-blue hover:text-white">
                {item.offering_name}
              </button>
            ))}
          </div>
        </div>
      ) : (
        ""
      )}
      {product.highlights ? (
        <div className="mt-14 ">
          <div className="col-span-3 sm:col-span-2">
            <div
              className={`${styles.highlightContainer} text-gray-500 w-40 font-bold text-base sm:text-xl text-left`}
            >
              {content["highlights"][lang]}
            </div>
          </div>
          <div
            className={`${styles.highlightsWrapper} ${styles.highlightContainer} col-12 `}
            id="highlights"
            dangerouslySetInnerHTML={{
              __html: ReactHtmlParser(product.highlights),
            }}
          ></div>
        </div>
      ) : (
        ""
      )}
      {product.usp && product.usp_image ? (
        <div className="mt-14">
          <div className="col-span-3 sm:col-span-2">
            <div className={`${styles.upscImage}`}>
              {/* <Image
                unoptimized={true}
                layout="fill"
                width={200}
                height={150}
                loader={myLoader}
                src={product.usp_image}
                alt="upsc"
              /> */}
              <LazyLoad once>
                <img
                  width={200}
                  height={150}
                  src={product.usp_image}
                  alt="upsc"
                />
              </LazyLoad>
            </div>
          </div>
          <div
            className={`${styles.uspWrapper} col-span-8 sm:col-span-9`}
            id="highlights"
            dangerouslySetInnerHTML={{
              __html: ReactHtmlParser(product.usp),
            }}
          ></div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

React.memo(ProductBrief, (preProps, nextProps) => {
  if (JSON.stringify(preProps.product) !== JSON.stringify(nextProps.product))
    return true;
  return false;
});

export default ProductBrief;
